import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-affiliations',
  templateUrl: './affiliations.component.html',
  styleUrls: ['./affiliations.component.scss']
})
export class AffiliationsComponent implements OnInit {

  constructor(
      private meta: Meta,
      private titles: Title
  ) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI’s Affiliations: Building Strong Academic Partnerships');
        this.meta.updateTag({
            name: 'description',
            content: `Explore ARNI’s Affiliations with renowned institutions and organizations, fostering collaboration, excellence, and global academic connections.`
        });
    }

}
